<template>
    <CContainer v-if="status != 'LOADING'">
        <Loading />
        <CRow>
            <!-- <CCol col="12" sm="5" md="5" lg="4">
            <CCard>
                <CCardBody class="profile-header position-relative text-center px-0">
                    <div class="mx-auto px-5">
                        <img class="logo" v-if="publisher.avatar" :src="publisher.avatar" :alt="publisher.full_name" />
                        <FaIcon v-else icon="user" class="logo default text-affili-eggplant" />
                    </div>
                    <div class="text-right mx-2">
                        <div class="b-a-1 p-2">
                            <h5>در ازای هر خرید:</h5>
                            <span class="d-block ltr font-sm">4% - 6% کمیسیون پله‌ای</span>
                            <br/>
                            <h5>در ازای هر لید:</h5>
                            <span class="d-block font-sm">1000 ریال</span>
                        </div>

                        <div class="b-a-1 p-2 mt-2">
                            <h5>کمیسیون‌ها</h5>
                            <span class="d-block font-sm"><span class="font-weight-bold">مجموع: </span>1,000,0000 ریال</span>
                            <span class="d-block font-sm"><span class="font-weight-bold">30 روز اخیر: </span>300,000 ریال</span>
                        </div>

                        <div class="b-a-1 p-2 mt-2">
                            <h5>کانورژن‌ها</h5>
                            <span class="mfe-4 d-inline-block font-sm"><span class="font-weight-bold">مجموع: </span>100</span>
                            <span class="d-inline-block font-sm"><span class="font-weight-bold">30 روز اخیر: </span>3</span>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
            </CCol>-->
            <CCol col="12" sm="7" md="7" lg="8">
                <CCard>
                    <CCardBody class="profile-header position-relative">
                        <span class="d-block font-lg mb-2">{{ publisher.full_name }}</span>
                        <CButton
                            color="secondary"
                            class="d-inline-block small mfe-2"
                            :to="{ name: 'conversions', query: { user_id: publisher.id, store_id: publisher.store_id } }"
                        >مشاهده تراکنش‌ها</CButton>
                        <CSelect
                            v-if="publisher.status !== StoreUserRelationStatus.STOP_BY_PUBLISHER"
                            class="d-inline-block mfe-2"
                            addInputClasses="small"
                            :options="storeUserRelationStatusMerchantSideOption"
                            :value="publisher.status"
                            @update:value="value => changeStatus(value)"
                        />
                        <CSelect
                            class="d-inline-block mfe-2"
                            addInputClasses="small"
                            :options="selectableCommissionsGroupWithNull"
                            :value="publisher.group_id"
                            @update:value="value => updateGroup(value)"
                        />
                        <CButton
                            color="primary"
                            class="d-inline-block small mfe-2"
                            @click="modal = { show: true, item: exclusiveCommission }"
                        >کمیسیون</CButton>
                        <span class="d-block">
                            آخرین زمان فعالیت:
                            <span
                                class="font-weight-bold"
                            >{{ publisher.last_activity }}</span>
                        </span>
                        <span class="d-block">
                            فروش ناخالص:
                            <span
                                class="font-weight-bold"
                            >{{ publisher.gross_sales }} {{ $t('rial') }}</span>
                        </span>
                        <span class="d-block">
                            کل کلیک‌ها:
                            <span class="font-weight-bold">{{ publisher.clicks_count }}</span>
                        </span>
                    </CCardBody>
                </CCard>
                <CRow v-if="publisher.medias && publisher.medias.length > 0">
                    <CCol col="12" sm="4" v-for="(medium, index) in publisher.medias" :key="index">
                        <CLink class="hover-it" :href="medium.url" target="_blank">
                            <CCard>
                                <CCardBody>
                                    <FaIcon
                                        :icon="getIcon(medium.type)"
                                        class="fa-3x d-block mx-auto mb-3"
                                    />
                                    <span class="d-block text-center">{{ medium.name }}</span>
                                </CCardBody>
                            </CCard>
                        </CLink>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow>
            <CCol col="12">
                <CCard>
                    <CCardHeader>
                        <span>قوانین کمیسیونی</span>
                    </CCardHeader>
                    <CCardBody>
                        <Rules :publisherId="publisher.publisher_id" :storeId="storeId" />
                        <!-- <CTabs variant="tabs" :active-tab="1">
                            <CTab title="آمار 30 روز اخیر">
                                <div class="text-center py-4 font-weight-bold text-danger mt-3">
                                    <img
                                        src="https://img.icons8.com/office/80/000000/maintenance.png"
                                    />
                                    <span class="d-block mt-3">این بخش در حال پیاده سازی است.</span>
                                </div>
                            </CTab>
                            <CTab title="قوانین کمیسیونی">
                                <Rules class="mt-3" :publisherId="publisher.publisher_id" :storeId="storeId" />
                            </CTab>
                        </CTabs> -->
                    </CCardBody>
                </CCard>
            </CCol>
            <CModal color="primary" :show.sync="modal.show">
                <template #header-wrapper>
                    <span></span>
                </template>

                <ExclusiveForm :exclusiveCommission="exclusiveCommission" :submit="submit" />

                <template #footer-wrapper>
                    <span></span>
                </template>
            </CModal>
        </CRow>
    </CContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { StoreUserRelationStatus } from '@/constants'
import { checkCanActiveBlockedPublisher } from './partials/methods'
import Countdown from './partials/Countdown'
import { getIcon } from '@/views/media/partials/methods'
import { storeUserRelationStatusMerchantSideOption } from '@/common/data'
import Rules from '@/views/v2.commissions/Rules'
import { filterObject } from '@/common/objects'
import { commissionAmountTypeOption } from '@/common/data'
import { CommissionModel, CommissionAmountType, CommissionType } from '@/constants'
import { ExclusiveForm } from '../v2.commissions/partials/exclusive'

export default {
    name: 'Profile',

    components: {
        ExclusiveForm,
        Countdown,
        Rules,
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.findByRelId({
                rel_id: vm.id,
            }).then(result => {
                vm.storeId = result.data.store_id
                vm.fetchCommissions({
                    no_paginate: true,
                    store: {
                        id: result.data.store_id
                    },
                })
            })

        })
    },

    data() {
        return {
            CommissionAmountType,
            commissionAmountTypeOption,
            storeUserRelationStatusMerchantSideOption,
            StoreUserRelationStatus,
            id: this.$route.params.id,
            storeId: null,
            modal: {
                show: false,
            },
        }
    },

    computed: {
        ...mapGetters({
            individualCommissionRulesWherePublisherId: 'v2commission/individualCommissionRulesWherePublisherId',
            exclusiveCommissionWherePublisherId: 'v2commission/exclusiveCommissionWherePublisherId',
            // current: 'user/current',
            status: 'publisher/status',
            publisherById: 'publisher/publisherById',
            // status: 'publisher/status',
            commissions: 'v2commission/commissions',
            selectableCommissionsGroupWithNull: 'v2commission/selectableCommissionsGroupWithNull',
        }),
        defaults() {
            return filterObject(
                this.commissions,
                commission => commission.model === CommissionModel.INDIVIDUAL && commission.publisher_id === this.publisher.publisher_id && commission.type === CommissionType.MIX
            )
        },
        CommissionExclusive() {
            return this.exclusiveCommissionWherePublisherId(this.publisher.publisher_id) || {}
        },
        exclusiveCommission() {
            const defaultIndex = Object.keys(this.defaults)[0]

            const exclusiveCommission = defaultIndex ? this.defaults[defaultIndex] : {
                sale: {
                    action_type: CommissionAmountType.PERCENT,
                    action_value: '0'
                },
                lead: {
                    action_type: CommissionAmountType.AMOUNT,
                    action_value: '0'
                },
                model: CommissionModel.INDIVIDUAL,
                store_id: this.storeId,
                type: CommissionType.MIX,
                publisher_id: this.publisher.publisher_id
            }

            return exclusiveCommission
        },
        publisher() {
            return this.publisherById(this.id) || {}
        },
        isActive() {
            return this.publisher.status === StoreUserRelationStatus.ACTIVE
        },
        isRejected() {
            return this.publisher.status === StoreUserRelationStatus.REJECTED
        },
        isBlocked() {
            return this.publisher.status === StoreUserRelationStatus.BLOCKED
        },
        canActiveBlocked() {
            return checkCanActiveBlockedPublisher(this.publisher)
        },
        stoppedByPublisher() {
            return this.publisher.status === StoreUserRelationStatus.STOP_BY_PUBLISHER
        },
    },

    methods: {
        ...mapActions({
            findByRelId: 'publisher/findByRelId',
            publisherChangeStatus: 'publisher/changeStatus',
            changeGroup: 'publisher/changeGroup',
            fetchCommissions: 'v2commission/fetch',
            create: 'v2commission/create',
            edit: 'v2commission/edit',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        submit() {
            this.setShowLoading('modalLoading')
            if (Object.values(this.CommissionExclusive).length > 0) {
                this.edit(this.exclusiveCommission).then(() => {
                    this.setShowLoading(false)
                    this.modal.show = false
                })
            } else {
                this.create(this.exclusiveCommission).then(() => {
                    this.setShowLoading(false, 'modalLoading')
                    this.modal.show = false
                })
            }
        },
        changeStatus(status) {
            this.publisherChangeStatus({
                id: this.publisher.id,
                user_id: this.publisher.publisher_id,
                store_id: this.publisher.store_id,
                status: status,
            })
        },
        getIcon,
        updateGroup(group_id) {
            this.changeGroup({
                id: this.publisher.id,
                user_id: this.publisher.publisher_id,
                store_id: this.publisher.store_id,
                group_id: group_id,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.profile-header {
    // margin-bottom: 60px;
    .logo {
        border-radius: 50%;
        height: auto;
        width: 100%;
        max-width: 50px;
        max-height: 50px;
        padding: 2px;
    }
    @media screen and (max-width: 425px) {
        .logo {
            max-width: 50px;
        }
    }
}
::v-deep {
    .hover-it {
        display: block;
        transition: all 0.2s;
        color: gray;
        text-decoration: none !important;
        &:hover {
            color: #e53565 !important;
            box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.08) !important;
        }
    }
}
</style>